const footerScroll = document.querySelector('.footer__scroll');
if (footerScroll) {
    footerScroll.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}